import { Store } from 'redux'
import {
  PRIVATE_EVENTS
} from 'shared/constants/api'
import { createEvent } from 'utils/events'
import { listen } from 'utils/message'

type StoreSyncArgs = {
  syncWith: string,
  store: Store,
  name: string
}

const UseStoreSync = ({ store, syncWith, name }: StoreSyncArgs) => {

  listen({
    topic: `CONDUCTOR:action-from-${syncWith}`,
    handler: event => {
      store.dispatch({
        ...event.data.action,
        _foreignDispatch: true
      })
    }
  })

  createEvent(PRIVATE_EVENTS[`${name.toUpperCase()}_READY`])

  return store
}

export default UseStoreSync
